var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 160,
    viewBox: "0 0 402 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.321 147.21C237.082 147.21 265.261 119.031 265.261 84.2701C265.261 49.5093 237.082 21.3301 202.321 21.3301C167.56 21.3301 139.381 49.5093 139.381 84.2701C139.381 119.031 167.56 147.21 202.321 147.21Z",
    fill: "#FFD822"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5505 127.774H6.4304L0 100.245L72.9432 13.4355H112.329V98.6367H130.213V127.773H112.329V155.102H74.551V127.774H74.5505ZM74.5505 98.8373V58.4479L40.9927 98.8373H74.5505Z",
    fill: "#6C757D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M346.217 127.774H278.096L271.666 100.245L344.61 13.4355H383.995V98.6367H401.879V127.773H383.995V155.102H346.217V127.774ZM346.217 98.8373V58.4479L312.659 98.8373H346.217Z",
    fill: "#6C757D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M222.316 55.126L206.015 55.1407L181.857 55.1725L151.402 151.915H206.015H253.262L222.316 55.126Z",
    fill: "url(#paint0_linear_2436_5700)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M202.332 76.4395C220.059 76.4395 234.43 62.0689 234.43 44.3418C234.43 26.6148 220.059 12.2441 202.332 12.2441C184.605 12.2441 170.234 26.6148 170.234 44.3418C170.234 62.0689 184.605 76.4395 202.332 76.4395Z",
    fill: "#BFCBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M234.363 44.3418C234.363 44.3418 223.693 50.9199 202.086 50.9199C180.479 50.9199 170.082 44.3418 170.082 44.3418C170.082 44.3418 132.98 55.0274 132.98 62.4204C132.98 69.8135 174.586 76.4395 202.086 76.4395C229.586 76.4395 271.328 69.8135 271.328 62.4204C271.328 55.0274 234.363 44.3418 234.363 44.3418Z",
    fill: "#1B1A1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M168.578 44.749C168.578 44.749 172.222 63.8971 195.66 63.8971C219.099 63.8971 235.329 45.9091 235.329 45.9091C235.329 45.9091 225.169 49.0797 202.086 49.0797C179.003 49.0797 168.578 44.749 168.578 44.749Z",
    fill: "#3759AD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M201.17 12.4827V3.2793",
    stroke: "#FFD822",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M201.349 6.80038C203.227 6.80038 204.75 5.27806 204.75 3.40019C204.75 1.52232 203.227 0 201.349 0C199.472 0 197.949 1.52232 197.949 3.40019C197.949 5.27806 199.472 6.80038 201.349 6.80038Z",
    fill: "#D15B2D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M202.332 159.335C230.46 159.335 253.263 155.984 253.263 151.851C253.263 147.718 230.46 144.367 202.332 144.367C174.205 144.367 151.402 147.718 151.402 151.851C151.402 155.984 174.205 159.335 202.332 159.335Z",
    fill: "url(#paint1_linear_2436_5700)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M223.532 112.213L203.58 127.204C203.009 127.634 202.197 127.519 201.768 126.947L184.863 104.448C184.434 103.876 184.549 103.065 185.12 102.636L201.518 90.3154L209.759 91.7282L223.789 110.401C224.219 110.972 224.104 111.784 223.532 112.213Z",
    fill: "#FFD822"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M201.518 90.3154L209.759 91.7282L206.178 94.6668C205.709 95.0519 205.013 94.9682 204.649 94.4827L201.518 90.3154Z",
    fill: "#7188C3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M197.009 108.616C197.925 108.616 198.667 107.874 198.667 106.958C198.667 106.043 197.925 105.301 197.009 105.301C196.094 105.301 195.352 106.043 195.352 106.958C195.352 107.874 196.094 108.616 197.009 108.616Z",
    fill: "#BFCBEB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M206.038 101.832C206.954 101.832 207.696 101.09 207.696 100.174C207.696 99.2587 206.954 98.5166 206.038 98.5166C205.123 98.5166 204.381 99.2587 204.381 100.174C204.381 101.09 205.123 101.832 206.038 101.832Z",
    fill: "#BFCBEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M208.083 112.388C208.907 111.769 208.495 109.831 207.163 108.058C205.831 106.286 204.084 105.351 203.261 105.969C202.437 106.588 202.849 108.527 204.181 110.299C205.512 112.071 207.26 113.007 208.083 112.388Z",
    fill: "#1F3262"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M239.2 99.7219L231.596 100.556C231.216 100.598 231.03 100.103 231.347 99.8885C232.758 98.9351 234.785 97.0654 236.202 93.6445C237.646 90.156 237.35 88.0838 237.172 87.3899C237.13 87.2293 237.208 87.0618 237.354 86.9827L244.254 83.224C244.478 83.1021 244.756 83.2383 244.794 83.4904C244.974 84.7034 245.232 87.9527 243.725 91.8715C242.12 96.0438 239.932 98.9673 239.45 99.5844C239.388 99.6626 239.299 99.7109 239.2 99.7219Z",
    fill: "#BFCBEB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M153.328 128.026C152.439 130.233 149.821 138.267 156.297 143.421C156.654 143.705 157.143 143.767 157.558 143.578L167.21 139.187C167.919 138.865 168.141 137.971 167.67 137.351C166.143 135.345 163.483 131.057 164.561 126.643C164.777 125.756 163.997 124.95 163.109 125.162L154.166 127.306C153.786 127.397 153.473 127.663 153.328 128.026Z",
    fill: "#8BA2DB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M172.131 68.9247C176.807 68.9247 180.597 65.1346 180.597 60.4594C180.597 55.7842 176.807 51.9941 172.131 51.9941C167.456 51.9941 163.666 55.7842 163.666 60.4594C163.666 65.1346 167.456 68.9247 172.131 68.9247Z",
    fill: "#FFD822"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M232.534 68.9247C237.209 68.9247 240.999 65.1346 240.999 60.4594C240.999 55.7842 237.209 51.9941 232.534 51.9941C227.858 51.9941 224.068 55.7842 224.068 60.4594C224.068 65.1346 227.858 68.9247 232.534 68.9247Z",
    fill: "#FFD822"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M232.534 66.9606C236.124 66.9606 239.035 64.0501 239.035 60.4598C239.035 56.8695 236.124 53.959 232.534 53.959C228.944 53.959 226.033 56.8695 226.033 60.4598C226.033 64.0501 228.944 66.9606 232.534 66.9606Z",
    fill: "#BFCBEB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M202.266 72.3612C206.941 72.3612 210.731 68.5712 210.731 63.8959C210.731 59.2207 206.941 55.4307 202.266 55.4307C197.591 55.4307 193.801 59.2207 193.801 63.8959C193.801 68.5712 197.591 72.3612 202.266 72.3612Z",
    fill: "#FFD822"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M202.547 133.046V140.409",
    stroke: "#FFD822",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M209.451 130.285V134.427",
    stroke: "#FFD822",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M209.451 138.568V140.409",
    stroke: "#FFD822",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M195.645 129.824V133.966",
    stroke: "#FFD822",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M195.645 136.727V139.027",
    stroke: "#FFD822",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M215.717 30.5801C218.471 30.5801 220.704 28.3475 220.704 25.5933C220.704 22.8391 218.471 20.6064 215.717 20.6064C212.963 20.6064 210.73 22.8391 210.73 25.5933C210.73 28.3475 212.963 30.5801 215.717 30.5801Z",
    fill: "#D9E0F3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M225.381 37.7074C226.734 37.7074 227.831 36.6101 227.831 35.2565C227.831 33.9029 226.734 32.8057 225.381 32.8057C224.027 32.8057 222.93 33.9029 222.93 35.2565C222.93 36.6101 224.027 37.7074 225.381 37.7074Z",
    fill: "#D9E0F3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M201.169 35.7852C196.583 35.7852 194.898 38.1233 194.898 42.8C194.898 47.4767 199.489 50.7609 201.169 50.7609C202.848 50.7609 207.439 47.4762 207.439 42.8C207.439 38.1237 205.755 35.7852 201.169 35.7852Z",
    fill: "#94A8D9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M202.317 44.2674C202.317 44.2674 202.236 42.3522 203.478 41.4889C204.719 40.6257 206.553 41.246 206.553 41.246C206.553 41.246 206.599 43.6738 205.228 44.2545C203.479 44.9954 202.317 44.2674 202.317 44.2674Z",
    fill: "#BFCBEB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M200.093 44.2674C200.093 44.2674 200.174 42.3522 198.933 41.4889C197.692 40.6257 195.858 41.246 195.858 41.246C195.858 41.246 195.812 43.6738 197.182 44.2545C198.931 44.9954 200.093 44.2674 200.093 44.2674Z",
    fill: "#BFCBEB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M202.085 52.759C180.196 52.759 169.54 46.1758 169.097 45.8956C168.238 45.3517 167.982 44.215 168.526 43.3559C169.069 42.4968 170.206 42.2409 171.065 42.7844C171.161 42.8447 181.373 49.0772 202.084 49.0772C222.813 49.0772 233.297 42.8336 233.4 42.7706C234.267 42.2423 235.398 42.5133 235.929 43.3789C236.459 44.244 236.192 45.3737 235.327 45.9066C234.875 46.1869 223.962 52.759 202.085 52.759Z",
    fill: "#6C757D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M232.534 53.959C232.215 53.959 231.904 53.9898 231.598 54.034L226.312 62.3433C226.734 63.7357 227.611 64.9276 228.768 65.7526L235.732 54.8039C234.787 54.2682 233.698 53.959 232.534 53.959Z",
    fill: "#D9E0F3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M237.097 55.832L230.279 66.5503C230.982 66.8103 231.739 66.9598 232.532 66.9598C232.627 66.9598 232.719 66.9497 232.812 66.9456L238.531 57.9534C238.197 57.1518 237.705 56.4326 237.097 55.832Z",
    fill: "#D9E0F3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M202.161 70.3971C205.751 70.3971 208.662 67.4866 208.662 63.8963C208.662 60.306 205.751 57.3955 202.161 57.3955C198.571 57.3955 195.66 60.306 195.66 63.8963C195.66 67.4866 198.571 70.3971 202.161 70.3971Z",
    fill: "#BFCBEB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M202.161 57.3955C201.842 57.3955 201.531 57.4263 201.224 57.4705L195.939 65.7798C196.361 67.1723 197.238 68.3641 198.395 69.1892L205.359 58.2404C204.414 57.7047 203.325 57.3955 202.161 57.3955Z",
    fill: "#D9E0F3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M206.726 59.2705L199.908 69.9888C200.611 70.2487 201.368 70.3983 202.161 70.3983C202.256 70.3983 202.348 70.3882 202.441 70.384L208.16 61.3919C207.825 60.5903 207.334 59.871 206.726 59.2705Z",
    fill: "#D9E0F3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M172.13 66.9586C175.72 66.9586 178.631 64.0481 178.631 60.4578C178.631 56.8675 175.72 53.957 172.13 53.957C168.539 53.957 165.629 56.8675 165.629 60.4578C165.629 64.0481 168.539 66.9586 172.13 66.9586Z",
    fill: "#BFCBEB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M172.13 53.957C171.811 53.957 171.5 53.9879 171.193 54.032L165.908 62.3413C166.329 63.7338 167.206 64.9256 168.364 65.7507L175.328 54.8019C174.383 54.2663 173.293 53.957 172.13 53.957Z",
    fill: "#D9E0F3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M176.694 55.832L169.877 66.5503C170.58 66.8103 171.337 66.9598 172.13 66.9598C172.224 66.9598 172.316 66.9497 172.409 66.9456L178.129 57.9534C177.794 57.1518 177.303 56.4326 176.694 55.832Z",
    fill: "#D9E0F3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M202.331 12.2441C196.71 12.2441 191.427 13.6937 186.832 16.2329C187.248 16.0663 201.955 10.2806 216.658 18.4873C231.318 26.67 234.275 41.9549 234.371 42.4758C233.404 25.618 219.432 12.2441 202.331 12.2441Z",
    fill: "#D9E0F3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M271.328 62.4209C271.328 55.8805 242.405 46.7655 235.73 44.749C235.73 44.749 264.778 55.7475 265.475 61.3399C266.171 66.9291 250.618 71.385 250.603 71.385H250.604L261.185 68.7726C267.408 66.8205 271.328 64.6854 271.328 62.4209Z",
    fill: "#6C757D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M132.98 62.4209C132.98 55.8805 161.903 46.7655 168.578 44.749C168.578 44.749 139.531 55.7475 138.834 61.3399C138.137 66.9291 153.691 71.385 153.705 71.385H153.705L143.123 68.7726C136.9 66.8205 132.98 64.6854 132.98 62.4209Z",
    fill: "#6C757D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2436_5700",
    x1: 202.332,
    y1: 55.1262,
    x2: 202.332,
    y2: 151.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0985,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4121,
    stopColor: "#87898C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7167,
    stopColor: "#D4DBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2436_5700",
    x1: 202.333,
    y1: 144.367,
    x2: 202.333,
    y2: 159.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5954,
    stopColor: "#E6EAF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE0EC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error404.c60e90c9bdf33f46a6e67d6bd76f9668.svg";
export { ForwardRef as ReactComponent };